import axios from "../http";

const url = "/mall/wx/movie/apiProxy";

const request = {
  getMovieRepeat(movieName, opiId) {
    return axios.get('/mall/wx/movie/get-movie-repeat', { params: { movieName, opiId } });
  },

  mv_get_jsapi_ticket(url) {
    const formData = new FormData()
    formData.append('url', url)
    return axios.post('/v5/get-jsapi-ticket', formData)
  },

  createPartnerOrder(data = {}) {
    data.method = 'movie.createorder';

    var url_1 = url + "/" + data.method
    return axios.post(url_1, data);
  },

  getMovieDetail(data = {}) {
    data.method = 'movie.detail';
    var url_1 = url + "/" + data.method
    return axios.post(url_1, data);
  },

  getHotMovieList(data = {}) {
    data.method = 'movie.hot.list';
    var url_1 = url + "/" + data.method
    return axios.post(url_1, data);
  },

  getFutureMovieList(data = {}) {
    data.method = 'movie.future.list';
    var url_1 = url + "/" + data.method
    return axios.post(url_1, data);
  },

  get_cinema_list(data = {}) {
    data.method = 'movie.cinema.list';
    var url_1 = url + "/" + data.method
    return axios.post(url_1, data);
  },

  m_city_list(data = {}) {
    data.method = 'movie.city.list';
    var url_1 = url + "/" + data.method
    return axios.post(url_1, data);
  },

  getCountyList(data = {}) {
    data.method = 'movie.county.list';
    var url_1 = url + "/" + data.method
    return axios.post(url_1, data);
  },

  getCinemaDetail(data = {}) {
    data.method = 'movie.cinema.detail';
    var url_1 = url + "/" + data.method
    return axios.post(url_1, data);
  },

  getMovieCinemaDateList(data = {}) {
    data.method = 'movie.opi.date.list';
    var url_1 = url + "/" + data.method
    return axios.post(url_1, data);
  },

  movie_opi_list(data = {}) {
    data.method = 'movie.opi.list';
    var url_1 = url + "/" + data.method
    return axios.post(url_1, data);
  },

  getMovieCinemaSeat(data = {}) {
    data.method = 'movie.opi.seat';
    var url_1 = url + "/" + data.method
    return axios.post(url_1, data);
  },

  validate_selected_seat_list(data = {}) {
    data.method = 'movie.seat.validposition';
    var url_1 = url + "/" + data.method
    return axios.post(url_1, data);
  },

  getMemberCouponList(data = {}) {
    let url = 'member.coupon.list';
    return axios.request({
      url,
      data
    });
  },

  getMemberVipList(data = {}) {
    let url = 'member.coupon.vipcard.list';
    return axios.request({
      url,
      data
    });
  },

  getMemberOrderList(data = {}) {
    let url = 'member.h5.movieOrder.list';
    return axios.request({
      url,
      data
    });
  },

  cancelMemberOrder(data = {}) {
    let url = 'member.order.cancel';
    return axios.request({
      url,
      data
    });
  },

  deleteMemberOrder(data = {}) {
    let url = 'member.order.del';
    return axios.request({
      url,
      data
    });
  },

  getCouponInfo(data = {}) {
    let url = 'member.coupon.get';
    return axios.request({
      url,
      data
    });
  },

  bindCoupon(data = {}) {
    let url = 'member.coupon.bind';
    return axios.request({
      url,
      data
    });
  },

  getOrderDetail(data = {}) {
    let url = 'member.h5.movieOrder.getByTradeNo';
    return axios.request({
      url,
      data
    });
  }
};

export default request;
